import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import * as query from "@arcgis/core/rest/query";
import Query from "@arcgis/core/rest/support/Query";
import _ from "lodash";
import { APIs } from "../config/APIRoutes";
import { ServiceIndex } from "../config/APIRoutes";
import { API_Service } from "../config/APIRoutes";

export function queryProjectData(type, projectID) {
  // console.log("Service Index:", type);
  const layer = new FeatureLayer({
    url: `${API_Service.Url}/${type}`,
  });
  return new Promise(async (resolve, reject) => {
    try {
      // Adds layer to the map
      // console.log("Layer Query....", layer.toJSON());

      let whereClause = "1=1";
      if (projectID) {
        if (type === ServiceIndex.Projects)
          whereClause = whereClause + " and ID='" + projectID + "'";
        // else if (
        //   type === ServiceIndex.ServiceArea ||
        //   type === ServiceIndex.ProjectAssignments
        // )
        //   whereClause = whereClause + " and Project_ID='" + projectID + "'";
        else whereClause = whereClause + " and ProjectID='" + projectID + "'";
      }
      const areaQuery = {
        where: whereClause, // Set by select element
        spatialRelationship: "intersects", // Relationship operation to apply
        //   geometry: extent, // Restricted to visible extent of the map
        outFields: "*", // Attributes to return
        returnGeometry: false,
      };
      console.log("Layer Query executing....", whereClause);
      layer.queryFeatures(areaQuery).then(function (response) {
        // console.log("Layer Query result....", response);
        // response.features.forEach((item) => {
        // console.log("Layer Items....", item.toJSON());
        // });
        const resultInfo = response.features.map((item) => item.attributes);
        console.log("$$$Final Result....", resultInfo);
        // console.log("$$$Final Result....", resultInfo[0]?.Name);
        // returns a feature set with features containing the following attributes
        // STATE_NAME, COUNTY_NAME, POPULATION, POP_DENSITY
        resolve(resultInfo);
      });
    } catch (err) {
      console.log("Error in Layer Query....", err);
      reject(err);
    }
  });
}

export function queryProjectDatabyObjectId(type, objectId) {
  // console.log("Service Index:", type);
  const layer = new FeatureLayer({
    url: `${API_Service.Url}/${type}`,
  });
  return new Promise(async (resolve, reject) => {
    try {
      // Adds layer to the map
      // console.log("Layer Query....", layer.toJSON());

      let whereClause = "1=1";
      // if (projectID) {
      //   if (type === ServiceIndex.Projects)
      whereClause = whereClause + " and OBJECTID=" + objectId;
      // else if (
      //   type === ServiceIndex.ServiceArea ||
      //   type === ServiceIndex.ProjectAssignments
      // )
      //   whereClause = whereClause + " and Project_ID='" + projectID + "'";
      //   else whereClause = whereClause + " and ProjectID='" + projectID + "'";
      // }
      const areaQuery = {
        where: whereClause, // Set by select element
        spatialRelationship: "intersects", // Relationship operation to apply
        //   geometry: extent, // Restricted to visible extent of the map
        outFields: "*", // Attributes to return
        returnGeometry: false,
      };
      console.log("Layer Query executing....", whereClause);
      layer.queryFeatures(areaQuery).then(function (response) {
        // console.log("Layer Query result....", response);
        // response.features.forEach((item) => {
        // console.log("Layer Items....", item.toJSON());
        // });
        const resultInfo = response.features.map((item) => item.attributes);
        console.log("$$$Final Result....", resultInfo);
        // console.log("$$$Final Result....", resultInfo[0]?.Name);
        // returns a feature set with features containing the following attributes
        // STATE_NAME, COUNTY_NAME, POPULATION, POP_DENSITY
        resolve(resultInfo);
      });
    } catch (err) {
      console.log("Error in Layer Query....", err);
      reject(err);
    }
  });
}

export function queryServiceAreaData(type, serviceAreaID) {
  // console.log("Service Index:", type);
  const layer = new FeatureLayer({
    url: `${API_Service.Url}/${type}`,
  });
  return new Promise(async (resolve, reject) => {
    try {
      // Adds layer to the map
      // console.log("Layer Query....", layer.toJSON());
      let whereClause = "1=1";
      whereClause = whereClause + " and SA_ID='" + serviceAreaID + "'";
      const areaQuery = {
        where: whereClause, // Set by select element
        spatialRelationship: "intersects", // Relationship operation to apply
        //   geometry: extent, // Restricted to visible extent of the map
        outFields: "*", // Attributes to return
        returnGeometry: false,
      };
      console.log("Layer Query executing....", whereClause);
      layer.queryFeatures(areaQuery).then(function (response) {
        // console.log("Layer Query result....", response);
        // response.features.forEach((item) => {
        // console.log("Layer Items....", item.toJSON());
        // });
        const resultInfo = response.features.map((item) => item.attributes);
        console.log("$$$Final Result....", resultInfo);
        // console.log("$$$Final Result....", resultInfo[0]?.Name);
        // returns a feature set with features containing the following attributes
        // STATE_NAME, COUNTY_NAME, POPULATION, POP_DENSITY
        resolve(resultInfo);
      });
    } catch (err) {
      console.log("Error in Layer Query....", err);
      reject(err);
    }
  });
}

export function queryProjectFeatures(type, projectID) {
  // console.log("Service Index:", type);
  const layer = new FeatureLayer({
    url: `${API_Service.Url}/${type}`,
  });
  return new Promise(async (resolve, reject) => {
    try {
      // Adds layer to the map
      // console.log("Layer Query....", layer.toJSON());

      let whereClause = "1=1";
      if (projectID) {
        if (type === ServiceIndex.Projects)
          whereClause = whereClause + " and ID='" + projectID + "'";
        // else if (
        //   type === ServiceIndex.ServiceArea ||
        //   type === ServiceIndex.ProjectAssignments
        // )
        //   whereClause = whereClause + " and Project_ID='" + projectID + "'";
        else whereClause = whereClause + " and ProjectID='" + projectID + "'";
      }
      const areaQuery = {
        where: whereClause, // Set by select element
        spatialRelationship: "intersects", // Relationship operation to apply
        //   geometry: extent, // Restricted to visible extent of the map
        outFields: "*", // Attributes to return
        returnGeometry: true,
      };
      console.log("Layer Query executing....", whereClause);
      layer.queryFeatures(areaQuery).then(function (response) {
        // console.log("Layer Query result....", response);
        // response.features.forEach((item) => {
        // console.log("Layer Items....", item.toJSON());
        // });
        const resultInfo = response.features.map((item) => ({
          OBJECTID: item.attributes.OBJECTID,
          geometry: item.geometry,
        }));
        console.log("$$$Final Result....", resultInfo);
        // console.log("$$$Final Result....", resultInfo[0]?.Name);
        // returns a feature set with features containing the following attributes
        // STATE_NAME, COUNTY_NAME, POPULATION, POP_DENSITY
        resolve(resultInfo);
      });
    } catch (err) {
      console.log("Error in Layer Query....", err);
      reject(err);
    }
  });
}

export function queryProjectViewData(type, projectID) {
  console.log("@@View Index:", type);
  let queryUrl = `${API_Service.View_Url}/${type}`;
  let whereClause = "1=1";
  if (projectID)
    whereClause = whereClause + " and ProjectID='" + projectID + "'";

  // create a query for the MapService
  // var queryObject = new Query({
  //   returnGeometry: false,
  //   outFields: ["*"],
  //   where: whereClause, // Set by select element
  // });
  // create the Query object
  let queryObject = new Query();
  queryObject.where = whereClause;
  // queryObject.outSpatialReference = { wkid:4269 };
  queryObject.returnGeometry = false;
  queryObject.outFields = ["*"];
  console.log("@@Layer view Query where....", whereClause);
  return new Promise(async (resolve, reject) => {
    try {
      // Adds layer to the map
      // call the executeQueryJSON() method
      query
        .executeQueryJSON(queryUrl, queryObject)
        .then(function (response) {
          // console.log("@@Layer Query result....", response);
          response.features.forEach((item) => {
            // console.log("@@Layer Items....", item.toJSON());
          });
          const resultInfo = response.features.map((item) => item.attributes);
          console.log("@@Final View Result....", resultInfo);
          // console.log("@@Final Result....", resultInfo[0]?.Name);
          // returns a feature set with features containing the following attributes
          // STATE_NAME, COUNTY_NAME, POPULATION, POP_DENSITY
          resolve(resultInfo);
        })
        .catch((err) => {
          console.log("Error in View Layer Query....", err);
          reject(err);
        });
    } catch (err) {
      console.log("Error in View Layer Query....", err);
      reject(err);
    }
  });
}

export function queryProjectViewDataWithFilter(type, where) {
  console.log("@@View Index:", type);
  let queryUrl = `${API_Service.View_Url}/${type}`;
  // let whereClause = "1=1";
  // if (projectID)
  //   whereClause = whereClause + " and ProjectID='" + projectID + "'";

  // create a query for the MapService
  // var queryObject = new Query({
  //   returnGeometry: false,
  //   outFields: ["*"],
  //   where: whereClause, // Set by select element
  // });
  // create the Query object
  let queryObject = new Query();
  queryObject.where = where;
  // queryObject.outSpatialReference = { wkid:4269 };
  queryObject.returnGeometry = false;
  queryObject.outFields = ["*"];
  console.log("@@Layer view Query where....", where);
  return new Promise(async (resolve, reject) => {
    try {
      // Adds layer to the map
      // call the executeQueryJSON() method
      query
        .executeQueryJSON(queryUrl, queryObject)
        .then(function (response) {
          // console.log("@@Layer Query result....", response);
          response.features.forEach((item) => {
            // console.log("@@Layer Items....", item.toJSON());
          });
          const resultInfo = response.features.map((item) => item.attributes);
          console.log("@@Final View Result....", resultInfo);
          // console.log("@@Final Result....", resultInfo[0]?.Name);
          // returns a feature set with features containing the following attributes
          // STATE_NAME, COUNTY_NAME, POPULATION, POP_DENSITY
          resolve(resultInfo.length > 0);
        })
        .catch((err) => {
          console.log("Error in View Layer Query....", err);
          reject(err);
        });
    } catch (err) {
      console.log("Error in View Layer Query....", err);
      reject(err);
    }
  });
}

export function queryProjectDataWithFilter(type, where) {
  // console.log("Service Index:", type);
  const layer = new FeatureLayer({
    url: `${API_Service.Url}/${type}`,
  });
  return new Promise(async (resolve, reject) => {
    try {
      // Adds layer to the map
      // console.log("Layer Query....", layer.toJSON());

      // let whereClause = "1=1";

      const areaQuery = {
        where: where, // Set by select element
        spatialRelationship: "intersects", // Relationship operation to apply
        //   geometry: extent, // Restricted to visible extent of the map
        outFields: "*", // Attributes to return
        returnGeometry: false,
      };
      console.log("Layer Query executing....", where);
      layer.queryFeatures(areaQuery).then(function (response) {
        // console.log("Layer Query result....", response);
        // response.features.forEach((item) => {
        // console.log("Layer Items....", item.toJSON());
        // });
        const resultInfo = response.features.map((item) => item.attributes);
        console.log("$$$Final Result....", resultInfo);
        // console.log("$$$Final Result....", resultInfo[0]?.Name);
        // returns a feature set with features containing the following attributes
        // STATE_NAME, COUNTY_NAME, POPULATION, POP_DENSITY
        resolve(resultInfo);
      });
    } catch (err) {
      console.log("Error in Layer Query....", err);
      reject(err);
    }
  });
}

export function queryUnitsConfig(type) {
  console.log("Service Index:", type);
  const layer = new FeatureLayer({
    url: `${API_Service.Url}/${type}`,
  });

  return new Promise(async (resolve, reject) => {
    try {
      // Adds layer to the map
      console.log("Layer Query....", layer.toJSON());

      let whereClause = "1=1";
      //   if (projectID) whereClause = whereClause + " and Project_ID=" + projectID;
      const areaQuery = {
        where: whereClause, // Set by select element
        spatialRelationship: "intersects", // Relationship operation to apply
        //   geometry: extent, // Restricted to visible extent of the map
        outFields: "*", // Attributes to return
        returnGeometry: false,
      };
      let AllAssetTypes = null;
      layer.queryFeatures(areaQuery).then(async (response) => {
        console.log("&&&Layer Query result....", response);
        response.features.forEach((item) => {
          console.log("&&&Layer Items....", item.toJSON());
        });
        const resultInfo = response.features.map((item) => item.attributes);
        const groupIDs = _.map(resultInfo, "OBJECTID");
        console.log("&&&GroupIDs:", groupIDs);
        // let AllAssetTypes = await getAssetTypes(layer, resultInfo);
        try {
          // const groupIDs = _.map(resultInfo, "OBJECTID");
          // console.log("&&&GroupIDs:", groupIDs);
          layer
            .queryRelatedFeatures({
              objectIds: groupIDs,
              relationshipId: 2,
              outFields: ["*"],
              returnGeometry: false,
            })
            .then(function (relatedRecords) {
              console.log("&&&Final Result....", relatedRecords);
              console.log("&&&Final Result....", resultInfo);

              /**Combine into one result */
              AllAssetTypes = resultInfo.map((group) => {
                // let AssetTypes = [];
                console.log("&&&$Group", group);
                if (group?.hasOwnProperty("AssetGroupID")) {
                  console.log(
                    "&&&$Final Result....1",
                    relatedRecords[group.AssetGroupID]?.features
                  );
                  if (relatedRecords[group.AssetGroupID]?.features) {
                    console.log(
                      "&&&$Final Result....2",
                      _.map(
                        relatedRecords[group.AssetGroupID].features,
                        "attributes"
                      )
                    );

                    // group.AssetTypes = _.map(
                    //   relatedRecords[group.AssetGroupID].features,
                    //   "attributes"
                    // );
                    const AssetTypes = relatedRecords[
                      group.AssetGroupID
                    ].features.map((item) => item.attributes);
                    console.log("&&&$Final Result....3", AssetTypes);
                    // AssetTypes = _.map(AssetTypes, (type) => ({
                    //   ...group,
                    //   ...AssetTypes,
                    // }));
                    // let tmpGroup = "";
                    // AssetTypes = AssetTypes.map((type) => {
                    //   let rowspan =
                    //     tmpGroup === group.AssetGroupID ? 0 : AssetTypes.length;
                    //   tmpGroup = group.AssetGroupID;
                    //   return { ...group, ...type, rowspan };
                    // });
                    group.AssetTypes = AssetTypes;
                  }
                }

                // group.AssetTypes = AssetTypes;
                // AssetTypes = await Promise.all([...AssetTypes]);
                return group;
              });
              AllAssetTypes.forEach(async (group) => {
                if (group.AssetTypes)
                  group.AssetTypes = await Promise.all(group.AssetTypes);
              });
              console.log("&&&$Final Result AssetType....", AllAssetTypes);
              //   const AssetTypesLookup = await getSuffixInfo(AllAssetTypes);
              getSuffixInfo(AllAssetTypes)
                .then((AssetTypesLookup) => {
                  console.log(
                    "%%%Final Result AssetType...2",
                    AssetTypesLookup
                  );
                  resolve(AssetTypesLookup);
                })
                .catch((err) => {
                  console.log("Error in Main Fetching Suffix ....", err);
                });
            });
        } catch (err) {
          console.log("Error in Update Layer ....", err);
          // reject(false);
        }
      });
    } catch (err) {
      console.log("Error in Layer Query....", err);
      reject(err);
    }
  });
}

export function processProjectData(type, params, action) {
  console.log("Service Index:", type);
  console.log("Service Param:", params);
  console.log("Service Action:", action);
  // Get a reference to the feature layer
  const layer = new FeatureLayer({
    url: `${API_Service.Url}/${type}`,
  });
  return new Promise((resolve, reject) => {
    try {
      // Adds layer to the map
      console.log("Layer Query....", layer.toJSON());

      let whereClause = "1=1";
      if (action === "UPDATE" || action === "DELETE") {
        if (isIterable(params)) {
          whereClause =
            whereClause +
            ` and OBJECTID IN (${getObjectIDs(params).join(",")})`;
        } else {
          whereClause = whereClause + ` and OBJECTID = ${params.OBJECTID}`;
        }
      }

      const selectQuery = {
        where: whereClause, // Set by select element
        spatialRelationship: "intersects", // Relationship operation to apply
        //   geometry: extent, // Restricted to visible extent of the map
        outFields: "*", // Attributes to return
        returnGeometry: false,
      };
      console.log("Layer selectQuery ....", selectQuery);

      layer
        .queryFeatures(selectQuery)
        .then(function (response) {
          let features;
          if (isIterable(params)) {
            console.log("Feature Attr to be updated 0:", params);
            features = params.map((record) => ({ attributes: record }));
          } else {
            let _feature = response.features[0];
            console.log("#!#Feature :", _feature);
            let attrs = null;
            if (_feature) {
              attrs = _feature.attributes;
            }
            // if (action === "ADD" && feature) delete attrs.ObjectID;
            console.log("Feature Attr:", attrs);
            // Set the updated attribute values
            //   feature.setAttributes({ ...attrs, ...params });
            let feature = {};
            feature.attributes = { ...attrs, ...params };
            features = [feature];
          }
          console.log("Feature Attr to be updated:", features);

          let payload;
          if (action === "ADD") payload = { addFeatures: features };
          if (action === "UPDATE") payload = { updateFeatures: features };
          if (action === "DELETE") payload = { deleteFeatures: features };
          layer.applyEdits(payload).then((editsResult) => {
            // Get the objectId of the newly added feature.
            // Call selectFeature function to highlight the new feature.
            if (editsResult.addFeatureResults.length > 0) {
              console.log("Added ...", editsResult.addFeatureResults);
              resolve(editsResult.addFeatureResults);
            } else if (editsResult.updateFeatureResults.length > 0) {
              console.log("Updated ...", editsResult.updateFeatureResults);
              resolve(editsResult.updateFeatureResults);
            } else if (editsResult.deleteFeatureResults.length > 0) {
              console.log("Deleted ...", editsResult.deleteFeatureResults);
              resolve(editsResult.deleteFeatureResults);
            } else {
              console.log("Error in update ...");
            }
          });
        })
        .catch((error) => {
          console.log("Error in update ...", error);
          reject(false);
        });
    } catch (err) {
      console.log("Error in Update Layer ....", err);
      reject(false);
    }
  });
}

function getObjectIDs(data) {
  return data.map((item) => item.OBJECTID);
}
export function getFeatureData(data) {
  return data.features.map((item) => item.attributes);
}

async function getSuffixInfo(AllAssetTypes) {
  const layer2 = new FeatureLayer({
    url: `${API_Service.Url}/${ServiceIndex.ProjectAssetTypes}`,
  });
  console.log("&&&$getSuffixInfo");
  return new Promise(async (resolve, reject) => {
    try {
      console.log("&&&$isIterable AllAssetTypes", isIterable(AllAssetTypes));
      let ResultAssetTypes = [];
      if (isIterable(AllAssetTypes)) {
        ResultAssetTypes = AllAssetTypes.map(async (assetGroup) => {
          console.log(
            "&&&$isIterable assetGroup.AssetTypes",
            isIterable(assetGroup.AssetTypes)
          );
          const AssetTypeIDs = _.map(assetGroup.AssetTypes, "OBJECTID");
          console.log("&&&$AssetTypeIDs", AssetTypeIDs);
          if (isIterable(assetGroup.AssetTypes)) {
            assetGroup.AssetTypes = assetGroup.AssetTypes.map(
              async (assetType) => {
                let Suffix = {};
                const relatedSuffixes = await layer2.queryRelatedFeatures({
                  objectIds: AssetTypeIDs,
                  relationshipId: 1,
                  outFields: ["*"],
                  returnGeometry: false,
                });
                // .then(function (relatedSuffixes) {
                console.log("&&&$relatedSuffixes", relatedSuffixes);
                if (!_.isEqual(relatedSuffixes, {})) {
                  console.log(
                    "&&&$Mid Result....1",
                    relatedSuffixes[assetType.AssetTypeID]?.features
                  );
                  if (relatedSuffixes[assetType.AssetTypeID]?.features) {
                    console.log(
                      "&&&$Mid Result....2",
                      _.map(
                        relatedSuffixes[assetType.AssetTypeID].features,
                        "attributes"
                      )
                    );
                    Suffix = _.map(
                      relatedSuffixes[assetType.AssetTypeID].features,
                      "attributes"
                    );
                    console.log("&&&$Including Suffix", Suffix);
                  }
                } else {
                  console.log("&&&$Skipping Empty Suffix");
                }
                return { ...assetType, Suffix };
              }
            );
          }
          assetGroup.AssetTypes = await Promise.all(assetGroup.AssetTypes);
          console.log("&&&$assetGroup", assetGroup);
          return assetGroup;
        });
      }
      console.log("&&&$ResultAssetTypes...1", ResultAssetTypes);
      //   ResultAssetTypes = await Promise.all(ResultAssetTypes);
      //   console.log("&&&$ResultAssetTypes...2", ResultAssetTypes);

      resolve(ResultAssetTypes);
    } catch (err) {
      console.log("Error in Fetching Suffix ....", err);
      reject(false);
    }
  });
}

async function getAssetTypes(layer, resultInfo) {
  //   const layer = new FeatureLayer({
  //     url: `${API_Service.Url}/${type}`,
  //   });
  return new Promise(async (resolve, reject) => {
    try {
      const groupIDs = _.map(resultInfo, "OBJECTID");
      console.log("&&&GroupIDs:", groupIDs);
      layer
        .queryRelatedFeatures({
          objectIds: groupIDs,
          relationshipId: 2,
          outFields: ["*"],
          returnGeometry: false,
        })
        .then(function (relatedRecords) {
          console.log("&&&Final Result....", relatedRecords);
          console.log("&&&Final Result....", resultInfo);

          /**Combine into one result */
          let AllAssetTypes = resultInfo.map((group) => {
            let AssetTypes = [];
            console.log("&&&$Group", group);
            if (group?.hasOwnProperty("AssetGroupID")) {
              console.log(
                "&&&$Final Result....1",
                relatedRecords[group.AssetGroupID]?.features
              );
              if (relatedRecords[group.AssetGroupID]?.features) {
                console.log(
                  "&&&$Final Result....2",
                  _.map(
                    relatedRecords[group.AssetGroupID].features,
                    "attributes"
                  )
                );

                AssetTypes = _.map(
                  relatedRecords[group.AssetGroupID].features,
                  "attributes"
                );
                console.log("&&&$Final Result....3", AssetTypes);
                // AssetTypes = _.map(AssetTypes, (type) => ({
                //   ...group,
                //   ...AssetTypes,
                // }));
                // let tmpGroup = "";
                // AssetTypes = AssetTypes.map((type) => {
                //   let rowspan =
                //     tmpGroup === group.AssetGroupID ? 0 : AssetTypes.length;
                //   tmpGroup = group.AssetGroupID;
                //   return { ...group, ...type, rowspan };
                // });
              }
            }

            group.AssetTypes = AssetTypes;
            // AssetTypes = await Promise.all([...AssetTypes]);
            return group;
          });
          //   AllAssetTypes = _.flatten(AllAssetTypes, 1);
          //   AllAssetTypes = _.flatten(_.map(AllAssetTypes, "AssetTypes"), 2);
          console.log("&&&$Final Result AssetType....", AllAssetTypes);
          // console.log(
          //   "&&&$Final Result....2",
          //   _.flatten(_.map(AllAssetTypes, "AssetTypes"))
          // );
          // AllAssetTypes = await getSuffixInfo(AllAssetTypes);
          // console.log("&&&$Final Result AssetType...2", AllAssetTypes);
          resolve(AllAssetTypes);
        });
    } catch (err) {
      console.log("Error in Update Layer ....", err);
      reject(false);
    }
  });
}

function getValueFromPromise(arrPromises) {
  const getValues = async () => {
    return await Promise.all(arrPromises);
  };
  const values = getValues();
  console.log("&&&&&VALUES: ", values);
  //   values.then((final) => {
  //     console.log("&&&&&Final VALUES: ", final);
  //   });
  return values;
}
function isIterable(input) {
  if (input === null || input === undefined) {
    return false;
  }

  return typeof input[Symbol.iterator] === "function";
}

export function groupTypes(AssetGroups, assetLookup = null, raw = null) {
  console.log("Group Types", raw, AssetGroups[0].AssetGroupID);
  AssetGroups = AssetGroups.reduce((carry, current) => {
    //AssetTypeID, AssetName, SuffixID, Suffix, AssignedTo
    let { OBJECTID, AssetGroupID, AssetGroupType, FeatureType, ...AssetTypes } =
      current;
    if (assetLookup) {
      const currentLookup = assetLookup.find(
        (asset) => asset.AssetGroupID === current.AssetGroupID
      );
      console.log("Current Lookup", currentLookup);
      if (!AssetGroupType || !FeatureType) {
        AssetGroupType = currentLookup.AssetGroupType;
        FeatureType = currentLookup.FeatureType;
      }
    }
    let el = carry.find((item) => item.AssetGroupID === AssetGroupID);
    if (!el) {
      el = {
        OBJECTID,
        AssetGroupID,
        AssetGroupType,
        FeatureType,
        AssetTypes: [],
      };
      carry.push(el);
    }

    el.AssetTypes.push({ ...AssetTypes });
    // el.AssetTypes = groupSuffixes(el.AssetTypes);
    return carry;
  }, []);
  console.log("&&&&&Processing AssetTypes: ", AssetGroups);
  const retAssetGroups = AssetGroups.map((group) => {
    group.AssetTypes = groupSuffixes(
      group.AssetTypes,
      group.AssetGroupID,
      assetLookup
    );
    return group;
  });
  return retAssetGroups;
}

function groupSuffixes(AssetTypes, AssetGroupID, assetLookup = null) {
  console.log(
    "&&&&&Processing AssetTypes: ",
    AssetTypes,
    AssetGroupID,
    assetLookup
  );
  const retAssetTypes = AssetTypes.reduce((carry, current) => {
    //AssetTypeID, AssetName, SuffixID, Suffix, AssignedTo
    let { AssetTypeID, AssetName, ...Suffixes } = current;
    if (assetLookup) {
      let currentAsset = assetLookup.find(
        (item) => item.AssetGroupID === AssetGroupID
      );
      console.log("Cuurent Asset", currentAsset);
      currentAsset = currentAsset.AssetTypes.find(
        ({ AssetTypeID: typeID }) => AssetTypeID === typeID
      );
      if (!AssetName) {
        AssetName = currentAsset.AssetName;
      }
      Suffixes.SuffixName = currentAsset.Suffixes.find(
        (i) => i.SuffixID === Suffixes.SuffixID
      )?.SuffixName;
    }

    let el = carry.find((item) => item.AssetTypeID === AssetTypeID);
    if (!el) {
      el = {
        AssetTypeID,
        AssetName,
        Suffixes: [],
      };
      carry.push(el);
    }
    el.Suffixes.push({ ...Suffixes });
    return carry;
  }, []);
  return retAssetTypes;
}
